import React from 'react';
import PropTypes from 'prop-types';

import Icon from '@component/icon';
import PopTip from '@component/info/poptip';

import { WHITE } from '@constant/colors';

const FeedbackOption = ({ onClick, imageUrl, message, selected }) => {
  return (
    <div className="feedback__option">
      <PopTip
        content={<span>{message}</span>}
        offset={15}
        className="feedback__option-tooltip"
      >
        <button onClick={onClick} className="feedback__option-button">
          {selected && (
            <div className="feedback__option-selected-filter">
              <Icon
                type="Valid"
                className="feedback__option-selected-icon"
                color={WHITE}
              />
            </div>
          )}
          <img
            src={imageUrl}
            className="feedback__option-image"
            alt={message}
          />
        </button>
      </PopTip>
    </div>
  );
};

FeedbackOption.propTypes = {
  onClick: PropTypes.func.isRequired,
  imageUrl: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
};

export default FeedbackOption;
